import(/* webpackMode: "eager" */ "/vercel/path0/app/solutions/forward-auction/page.tsx");
